const list = {
  "iran-qom": 26,
  "iran-ilam": 3,
  "iran-fars": 17,
  "iran-yazd": 29,
  "iran-gilan": 10,
  "iran-kerman": 2,
  "iran-qazvin": 9,
  "iran-alborz": 27,
  "iran-tehran": 25,
  "iran-hamadan": 8,
  "iran-markazi": 5,
  "iran-zanjan": 11,
  "iran-semnan": 12,
  "iran-lorestan": 4,
  "iran-bushehr": 18,
  "iran-ardabil": 19,
  "iran-isfahan": 13,
  "iran-golestan": 21,
  "iran-hormozgan": 30,
  "iran-khuzestan": 31,
  "iran-kurdistan": 15,
  "iran-kermanshah": 7,
  "iran-mazandaran": 20,
  "iran-northkhorasan": 1,
  "iran-southkhorasan": 23,
  "iran-eastazerbaijan": 28,
  "iran-razavikhorasan": 22,
  "iran-westazerbaijan": 16,
  "iran-sistanandbaluchestan": 24,
  "iran-chaharmahalandbakhtiari": 6,
  "iran-kohgiluyehandboyerahmad": 14,
}

export const getProvinceCode = (cityName) => {
  return list[cityName];
}